import { setupMatchMedia } from "@tamagui/web";
import { matchMedia } from "./matchMedia.mjs";
function createMedia(media) {
  return setupMatchMedia(matchMedia), media;
}
export { createMedia };
//# sourceMappingURL=createMedia.mjs.map
